var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"current-legend"},[_c('div',{staticClass:"current-legend__color-blocks"},_vm._l((_vm.dataInfos),function(d){return _c('div',{key:d.value,staticClass:"current-legend__color-blocks__block",style:({
        width: ((100 / _vm.dataInfos.length) + "%"),
        'background-color': d.color
      })})}),0),_c('div',{staticClass:"current-legend__lower"},[_vm._v(" more spending ⟶ ")])])}
var staticRenderFns = []

export { render, staticRenderFns }